import React, { useState, useEffect } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { getScrollTop } from '@/utils/common'
// import { Link } from 'react-router-dom'

import './index.less'

const style = {
  weibo: {
    left: 74,
  },
  qq: {
    left: 128,
  },
}

const data = {
  'jjfa':[{
    src: '/industryApplications/jinzong',
    text: '数据金融',
  }, {
    src: '/industryApplications/digitalJustice',
    text: '数字司法',
  }, {
    src: '/industryApplications/dataAssets',
    text: '数据资产',
  }, {
    src: '/industryApplications/digitalPassport',
    text: '数字护照',
  }, {
    src: '/industryApplications/mediation',
    text: '商事调解',
  }, {
    src: '/industryApplications/digitalAssets',
    text: '智能资产',
  }],
  'sszx': [{
     src: '/news',
    text: '公司快讯',
  },{
     src: '/news',
    text: '产业资讯',
  }],
  'aboutUs': [{
    src: '/about#introduction',
    text: '公司介绍',
  }, {
    src: '/about#develop',
    text: '发展历程',
  }, {
    src: '/about#honor',
    text: '荣誉奖项',
  }, {
    src: '/about#contact',
    text: '联系我们',
  }
  ],
  'yqlj': [{
    src: 'https://www.tssldc.com/',
    text: '天枢数链',
  }, {
    src: 'https://new.baoquan.com/',
    text: '掌上取证',
  },{
    src: 'https://shunong.shuqinkeji.com/#/fornt/home',
    text: '数农网',
  },{
    src: 'http://www.gsm.pku.edu.cn/',
    text: '北大光华',
  },{
    src: 'http://www.zju.edu.cn/',
    text: '浙江大学',
  },{
    src: 'https://tds.dataqin.com/',
    text: '可信数据空间',
  }],
  'xwmt': [{
    src: 'http://paper.people.com.cn/',
    text: '人民日报',
  }, {
    src: 'https://www.cls.cn/',
    text: '财联社',
  },{
    src: 'http://www.caict.ac.cn/',
    text: '中国信通院',
  },{
    src: 'https://account.bitfactory.cn/',
    text: '星火·链网',
  },{
    src: 'http://www.shbta.cn/',
    text: '上海区块链技术协会',
  },{
    src: 'https://www.huoxing24.com/',
    text: '火星财经',
  }]
}

function Foot(props) {
  const [followActive, setFollowActive] = useState(-1)
  const history = useHistory()
  const currentYear = new Date().getFullYear()

  function changeFollow(key) {
    setFollowActive(key)
  }
  useEffect(() => {
    setFollowActive(window.location.pathname)
  }, [])

  // function goWeibo(item) {
  //   if (item.className === 'weibo') {
  //     const w = window.open('about:blank')
  //     w.location.href = item.src
  //   }
  // }

  return (
    <footer className="page_foot">
      <div className='footer_top'>
        <div className="footer_top_inner" style={{display: 'flex'}}>
          <div className='footer_top_item'>
            <img src={require('../../assets/image/home/footer_top1.png')} style={{width: 50, height: 52}}/>
            <span>7*24小时安全保障</span>
          </div>
          <div className='footer_top_line'></div>
          <div className='footer_top_item'>
            <img src={require('../../assets/image/home/footer_top4.png')} style={{width: 32, height: 28}}/>
            <span>专业技术服务支持</span>
          </div>
          <div className='footer_top_line'></div>
          <div className='footer_top_item'>
            <img src={require('../../assets/image/home/footer_top2.png')} style={{width: 28, height: 28}}/>
            <span>多种解决方案提供</span>
          </div>
          <div className='footer_top_line'></div>
          <div className='footer_top_item'>
            <img src={require('../../assets/image/home/footer_top3.png')} style={{width: 28, height: 28}}/>
            <span>客户价值为先</span>
          </div>
        </div>
      </div>
      <div className="page_foot_inner" style={{display: 'flex', justifyContent: 'space-between', marginBottom: '48px'}}>
          <div className='page_foot_left'>
              <img
                  className="footer_logo"
                  src={require('../../assets/image/home/logo.png')}
                />
                <img
                  className="footer_qr"
                  src={require('../../assets/image/home/bottom_qr.png')}
                />
                <span className="text-group_29">数秦公众号</span>
          </div>
          <div className='footer_right'>
            <div className='footer_right_title'>核心能力</div>
            <div className='footer_li_link' onClick={() => history.push('/coreCompetencies')}>可信数据空间</div>
          </div>
          <div className='footer_right'>
            <div className='footer_right_title'>解决方案</div>
            {
              data.jjfa.map(item => <div className='footer_li_link' key={item.text} onClick={() => history.push(`${item.src}`)}>{item.text}</div>)
            }
          </div>
          <div className='footer_right'>
            <div className='footer_right_title'>实时资讯</div>
            {
              data.sszx.map(item => <div className='footer_li_link' key={item.text} onClick={() => history.push(`${item.src}`)}>{item.text}</div>)
            }
          </div>
          <div className='footer_right'>
            <div className='footer_right_title'>关于我们</div>
            {
              data.aboutUs.map(item => <div className='footer_li_link' key={item.text} onClick={() => history.push(`${item.src}`)}>{item.text}</div>)
            }
          </div>
          <div className='footer_right'>
            <div className='footer_li'>联系电话</div>
            <div className='footer_li_tel'>0571-87292902</div>
            <div className="footer_li">联系地址</div>
            <div className="footer_li_address">浙江省杭州市余杭区未来科技城良睦路1166号鼎创财富中心B1幢11F</div>
          </div>
      </div>
      <div className="page_foot_inner">
        <div className='footer_bottom'>
            <span className='footer_bottom_first'>友情链接</span>
            {
              data.yqlj.map(item => <span  key={item.text} onClick={() => window.open(item.src)}>{item.text}</span>)
            }
          </div>
          <div className='footer_bottom'>
            <span className='footer_bottom_first'>新闻媒体</span>
            {
              data.xwmt.map(item => <span key={item.text} onClick={() => window.open(item.src)}>{item.text}</span>)
            }
          </div>
          <div className='footer_bottom' style={{display: 'flex', justifyContent: 'space-between'}}>
            <div>
              <span className='footer_bottom_first'>隐私条款</span>
              <span onClick={() => history.push(`/disclaimer`)}>免责声明</span>
              <span>版权所有@数秦科技</span>
            </div>
            <div>
              <a className="beian" target="_blank" href="https://beian.miit.gov.cn/">
                <span>浙ICP备15025396号-5</span>
              </a>
              <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010602007260" target="_blank">
                <span><img src={require('../../assets/image/home/gongan.png')} alt="" />&nbsp;浙公网安备&nbsp;33010602007260号</span>
              </a>
            </div>
           
          </div>
        </div>
       
      <div className='page_bottom'>
      Copyright © {currentYear} DataQin All Rights Reserved Powered by 浙江数秦科技有限公司
      </div>
    </footer>
  )
}

export default Foot
